import {
  CAPABILITIES,
  CAPABILITY_MIN_ROLE,
  type Capability,
} from '@brew/auth/rbac'
import { errorCopy } from '@/lib/errors/error-copy'

/**
 * The refusal for someone without access to the brand, in English: what API
 * and MCP responses carry. The emails area words it in the reader's language
 * (`emails.access.memberRequired`).
 */
export const MEMBER_ACCESS_REQUIRED_COPY = errorCopy(
  'You do not have access to this brand. Ask an organization admin to add you to it.'
)

/** Permission explanations are derived from the same policy as enforcement. */
export const CAPABILITY_DENIED_COPY = Object.fromEntries(
  CAPABILITIES.map((capability) => [
    capability,
    CAPABILITY_MIN_ROLE[capability] === 'org_admin'
      ? errorCopy('Organization admin access is required.')
      : MEMBER_ACCESS_REQUIRED_COPY,
  ])
) as Readonly<Record<Capability, string>>
